import React from 'react';
import { useSelector } from 'react-redux';
import { Icon, Popup } from 'semantic-ui-react';

import { ActivityPopup } from 'shared/forms/NewActivity';
import { PRODUCT_PERMISSIONS, productRestriction, BannedIcon } from 'dyl-components';

const TextIcon = ({ contact_id, account_id, isActivityFormOpen, onOpenActivityForm, onCloseActivityForm, phone, onOpenTextModal, primary, size, style, disabled, position = 'bottom left', iconClassName = '' }) => {
    const productPermissions = useSelector((state) => state.subscription.productPermissions);
    const hasText = productRestriction(PRODUCT_PERMISSIONS.TEXT_VIEW, productPermissions);
    const isUnsubscribedFromTexting = useSelector((state) => state.text.unsubscribedPhones?.includes(phone));
    const isReadingUnsubscribedPhones = useSelector(state => state.text.isReadingUnsubscribedPhones);
    return (
        hasText ? (!isUnsubscribedFromTexting ?
            <Popup
                content="Send Text"
                trigger={
                    <span>
                        <Icon
                            size={size}
                            style={style}
                            className={`${iconClassName} fa-solid fa-comments`}
                            link
                            disabled={!phone || disabled || isReadingUnsubscribedPhones}
                            onClick={onOpenTextModal}
                            {...(primary ? { color: 'primary' } : {})}
                        />
                    </span>
                }
                on="hover"
                position="top center"
                inverted
                disabled={!phone || disabled || isReadingUnsubscribedPhones}
            />
            : (
                <BannedIcon primary={primary} size={size} style={style} iconClassName={iconClassName} iconName={'fa-solid fa-comments'} />
            )) : 
            <ActivityPopup
                trigger={
                    <Icon disabled={!phone || disabled} size={size} style={style} className={`${iconClassName} fa-solid fa-comments`} link  {...(primary ? { color: 'primary' } : {})} />
                }
                activityProps={{
                    hideActivitySelection: true,
                    textOnly: true,
                    contact: { id: contact_id || null },
                    account: { id: account_id },
                    isContact: !!contact_id
                }}
                open={isActivityFormOpen}
                onOpen={onOpenActivityForm}
                onClose={onCloseActivityForm}
                position={position}
            />
    )
}

export default TextIcon;
